module.exports = __webpack_public_path__ + "static/media/news-practice.b447472d.jpg";